import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const BlankScreenLoadingErrorView = () => {
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.BlankScreenLoadingError
  });
};
export default BlankScreenLoadingErrorView;